import { ThemeProvider as MuiThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { LicenseInfo } from "@mui/x-license-pro";

import { AdapterLuxonLocaleWeeks } from "./AdapterLuxonLocaleWeeks";
import { theme } from "./theme/theme";

if (!LicenseInfo.getLicenseKey()) {
  LicenseInfo.setLicenseKey(
    "2ac1ca3cdf82e38b7503d62730cf9e98Tz0xMzAyNDcsRT0xODE2Mzg3MTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=",
  );
}

export const ThemeProvider = ({ children }: React.PropsWithChildren) => {
  // Use browser's locale or fallback to en-US; force Sunday-first for en-US via Unicode extension (fw=sun)
  const browserLocale = navigator?.language || "en-US";
  const locale = browserLocale.toLowerCase() === "en-us" ? `${browserLocale}-u-fw-sun` : browserLocale;

  return (
    <LocalizationProvider dateAdapter={AdapterLuxonLocaleWeeks} adapterLocale={locale}>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </LocalizationProvider>
  );
};
